import React from 'react';
import ReactDOM from 'react-dom';
import api from './api';
import { canDo } from '../utils/canDo';
import './Doctors.css';
import PatientDetails from './PatientDetails';
import PatientDailyActivity from './PatientDailyActivity';

//import { useLocation } from 'react-router-dom';
import { FaInfoCircle, FaEdit, FaTrash, FaRupeeSign, FaTimes } from 'react-icons/fa'; // Add this import at the top of your file
import CustomDataTable from './CustomDataTable';
import SafeImage from './SafeImage';
import SaadhakExpandedRow from './SaadhakExpandedRow';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ClickPicture from './ClickPicture';
import DataTable from 'react-data-table-component';
import MiniCalendarWithBlocks from './MiniCalendarWithBlocks';

// ...

class ListPatients extends React.Component {
  

  constructor(props) {
    super(props);

    this.state = {
      auth: props.auth.auth || {},
      activeTab: 'MYCTherapy',
      isOwner: false,
      canSeeOutstanding: false,
      showScheduleModal: false,
      selectedAppt: null,
      futureDate: null,
      showDatePicker: false,
      schedulePlannedDuration: 50,
      isOnlineSchedule: false,
      allappointments: [],
      patients: [],
      branches: [],
      loading: true,
      hasMore: false,
      totalPatients: 0,
      serverActiveNow: 0,
      serverOutstanding: 0,
      // Today granular
      todayScheduled: 0, todayInProgress: 0, todayCompleted: 0, todayMissed: 0,
      // Week granular
      weekScheduled: 0, weekCompleted: 0, weekMissed: 0,
      // Month granular
      monthScheduled: 0, monthCompleted: 0, monthMissed: 0,
      dateRanges: null,
      filters: {
        name: '',
        card: '',
        contact: '',
        pending: '',
        lastVisit: '',
        therapist: ''
      },
      globalSearch: '',
      statsFilter: null, // 'active' | 'today' | 'week' | 'month' | 'outstanding' | null
      newPatient: this.emptyPatient(),
      selectedPatient: null,
      showBillsModal: false,
      expandedSections: {
        summary: true,
        section2: false,
        section3: false,
      },
      onlinePatientCards: new Set(),
      bills: [],
     // selectedPatientNow: this.emptyNow(),
     // newPatientNow: this.emptyNow(),
      isEditMode: false,
      isModalOpen: false,
      hasModalChanged: false,
      modalData: null,
      therapistView: '',
      showCamera: false,
      tabToSelect: '',
      registrationDate: this.formatDate(new Date()),
      // In-app dialog state (replaces window.alert / window.confirm)
      appDialog: null, // { type: 'alert'|'confirm', msg, onConfirm, alertType }
      pendingSummary: null, // cached server summary data, shown as "refresh available" banner
    };
    const navState = window.history.state?.usr;
    this.stateData = navState?.data || null;
    
    //const stateData = location.state?.data;
  }

 // ── In-app dialog helpers ──────────────────────────────────────────────────
 showAppAlert = (msg, alertType = 'info') => {
   if (this._alertTimer) clearTimeout(this._alertTimer);
   this.setState({ appDialog: { type: 'alert', msg, alertType } });
   // Auto-dismiss: errors stay 6s, others 3s
   const delay = alertType === 'error' ? 6000 : 3000;
   this._alertTimer = setTimeout(() => this.dismissAppDialog(), delay);
 };

 showAppConfirm = (msg, onConfirm) => {
   this.setState({ appDialog: { type: 'confirm', msg, onConfirm } });
 };

 dismissAppDialog = () => this.setState({ appDialog: null });

 componentDidMount = () => {
  
  console.log("state = ", this.state.auth);

  const auth = this.state.auth;
  // patients.view = see all patients; patients.view_own = see only assigned patients
  // If user has patients.view → full list; otherwise if view_own → therapist (assigned) view
  var therapistView = '';
  if (!canDo(auth, 'patients.view') && canDo(auth, 'patients.view_own')) {
    therapistView = 'PatientDailyActivity';
  }

  const stateData = this.props.location?.state?.data;

  //var isOwner = ["owner", "admin", "supervisor"].some(role =>  roles.includes(role)  );
  const isOwner = canDo(this.state.auth, 'patients.delete');
  const canSeeOutstanding = canDo(this.state.auth, 'patients.view_outstanding');
  //this.setState({isOwner: isOwner});  

   this.setState({ therapistView, isOwner, canSeeOutstanding }, () => {
    if (
      stateData &&
      stateData?.pc &&
      (stateData?.fromTab === 'Billing' &&
      stateData?.toTab === 'PostConsultation' ) ||
      (stateData?.fromTab === 'CIV' &&
      stateData?.toTab === 'PostConsultation' ||   stateData?.toTab === 'LabReadingsView' ) ||
      (stateData?.fromTab === 'TherapistDashboard' &&
      stateData?.toTab === 'PatientSequences' ) ||
      (stateData?.fromTab === 'LabReadingsView' &&
      stateData?.toTab === 'PostConsultation' ) 

    ) {
      console.log('Navigated with:', stateData);
      this.fetchPatientByCard(stateData.pc);
      // PARUL --> need session storage GET here ?
    }
    else
    {
         this.fetchData();
    }
  });

  // Re-fetch patient data when page becomes visible again (e.g. after completing sessions in SIV)
  this._onVisibility = () => {
    if (!document.hidden) this.refreshSummary();
  };
  document.addEventListener('visibilitychange', this._onVisibility);

  // Check for new data every 60s — show refresh banner instead of auto-applying
  this._refreshInterval = setInterval(() => {
    if (!document.hidden) this.checkForUpdates();
  }, 60000);
};

  componentWillUnmount() {
    if (this._onVisibility) {
      document.removeEventListener('visibilitychange', this._onVisibility);
    }
    if (this._refreshInterval) {
      clearInterval(this._refreshInterval);
    }
  }


  fetchPatientByCard = (patientCard) => {
    api.get(`${process.env.REACT_APP_URL}/patients/consultation/${patientCard}?t=${Date.now()}`)
      .then((response) => {
        var patient = response.data;
        
          var pcData = JSON.parse(sessionStorage.getItem("PCData"));
          console.log("pcData = ", pcData);
          if (pcData.patientCard == patientCard)
          {
            patient["name"] = pcData.name;
            patient["number"] = pcData.number;
            patient["branch"] = pcData.branch;
          }
          console.log("patient = ", patient);
        
        this.setState({
          selectedPatient: pcData, //patient,
          isModalOpen: true,
          hasModalChanged: true,
          modalData: patient,
          therapistView: '',
          tabToSelect: this.stateData.toTab || "PostConsultation",
        });
      })
      .catch((error) => {
        console.error('Error fetching patient by card:', error);
      });
  };
 
  fetchBillsByCard = async (row) => {
      try {
        const res = await api.get(`${process.env.REACT_APP_URL}/bills/${row.patientCard}?t=${Date.now()}`);
        const bills = res.data || [];
        this.setState({
            bills: bills,
            showBillsModal: true,
            selectedPatient: row,
          });
        } catch (err) {
          console.error('Failed to fetch bills:', err);
          alert('Could not load bills for this patient.');
        }
    };

BillDetails = ({ data }) => {
  const computeServiceTotal = (svc) => {
    const qty = svc.qty || 1;
    let subtotal = qty * (svc.amount || 0);
    const gst = (svc.sgst || 0) + (svc.cgst || 0);
    if (gst > 0) subtotal += subtotal * gst / 100;
    else if (svc.igst) subtotal += subtotal * svc.igst / 100;
    if (svc.ecess) subtotal += subtotal * svc.ecess / 100;
    return Math.round(subtotal);
  };

  return (
    <div style={{ padding: '14px 20px', background: '#f8fafc', borderRadius: 10, margin: '4px 0', fontFamily: "'Inter','SF Pro Display',system-ui,sans-serif" }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Services</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
            <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Service</th>
            <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Rate</th>
            <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Qty</th>
            <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Tax</th>
            <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Disc.</th>
            <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 11, fontWeight: 700, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.services.map((svc, i) => {
            const gst = (svc.sgst || 0) + (svc.cgst || 0) + (svc.igst || 0) + (svc.ecess || 0);
            return (
              <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '8px 8px', color: '#1e293b', fontWeight: 500 }}>{svc.name}</td>
                <td style={{ padding: '8px 8px', textAlign: 'right', color: '#334155' }}>₹{svc.amount}</td>
                <td style={{ padding: '8px 8px', textAlign: 'right', color: '#334155' }}>{svc.qty || 1}</td>
                <td style={{ padding: '8px 8px', textAlign: 'right', color: '#94a3b8' }}>{gst > 0 ? `${gst}%` : '—'}</td>
                <td style={{ padding: '8px 8px', textAlign: 'right', color: '#b45309' }}>{svc.sdiscount || 0}</td>
                <td style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 700, color: '#0f172a' }}>₹{computeServiceTotal(svc)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

  billColumns = [
    { name: 'Bill ID', selector: row => row.invoicenumber, sortable: true, width: '90px', wrap: true,
      cell: row => <span style={{ fontSize: 12, fontWeight: 600, color: '#475569' }}>{row.invoicenumber}</span> },
    { name: 'Date', 
      selector: row => new Date(row.invoicedate),   // REAL date used for sorting
      format: row => new Date(row.invoicedate).toLocaleDateString('en-GB'), // visible text      
      sortable: true, width: '130px' },
    { name: 'Time', selector: row => new Date(row.invoicedate).toLocaleTimeString('en-US', { hour12: true }), sortable: true, width: '130px' },
   
    { name: 'Total', selector: row => row.total, sortable: true, right: true, width: '100px',
       cell: row => <span style={{ color: '#0f172a', fontWeight: 700, fontSize: 13 }}>₹{row.total}</span>
    },
    { name: 'Discount', selector: row => row.discount, sortable: true, width: '90px',
       cell: row => <span style={{ color: '#64748b', fontSize: 13 }}>{row.discount || '—'}</span>
    },
    { name: 'Received', selector: row => row.paid, sortable: true, width: '100px',
       cell: row => <span style={{ color: '#15803d', fontWeight: 600, fontSize: 13 }}>₹{row.paid}</span>
    },
    { name: 'Change', selector: row => row.givenback, sortable: true, width: '90px',
       cell: row => <span style={{ color: '#64748b', fontSize: 13 }}>{row.givenback || '—'}</span>
    },
    { name: 'Balance', selector: row => row.balance, sortable: true, right: true, width: '100px',
       cell: row => (
        <span style={{ color: row.balance > 0 ? '#dc2626' : '#94a3b8', fontWeight: row.balance > 0 ? 700 : 400, fontSize: 13 }}>
           {row.balance > 0 ? `₹${row.balance}` : '—'}
        </span>
      )
     },
    { name: 'Org', selector: row => row.billorg, sortable: true, width: '120px', wrap: true,
       cell: row => <span style={{ fontSize: 12, color: '#475569' }}>{row.billorg}</span>
    },
  ];

  getLatestBranch = () => {
    const branches = this.state?.branches;
    if (!branches || !branches.length) return '';
    const active = branches.filter(b => b.isActive !== false && b.status !== 'inactive');
    if (!active.length) return '';
    // Prefer MedicalYogaTherapyCentre if it exists
    const myc = active.find(b => /^MedicalYog/i.test(b.name));
    if (myc) return myc.name;
    // Fallback to most recently created branch
    const sorted = [...active].sort((a, b) => {
      if (a.createdAt && b.createdAt) return new Date(b.createdAt) - new Date(a.createdAt);
      return 0;
    });
    return sorted[0].name;
  };

  emptyPatient = () => ({
    pic: '',
    branch: this.getLatestBranch() || '',
    name: '',
    age: '',
    gender: 'male',
    address: '',
    number: '',
    patientCard: '',
    registrationDate: this.formatDate(new Date()),
    status: 'provisional',
    occu: '',
    now: this.emptyNow()  // <== add this here
  });

  emptyNow = () => ({
    sit: false,
    stand: false,
    travel: false,
    mix: false,
    other: false
  });

  formatDate = (dateObj) => {
    const d = new Date(dateObj);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
  };

  rowsPerPage = 200;

  fetchData = (skip = 0, limit, statsFilterOverride) => {
    const { therapistView, auth } = this.state;
    const pageLimit = limit || this.rowsPerPage;
    const sf = statsFilterOverride !== undefined ? statsFilterOverride : this.state.statsFilter;

    // Therapist view returns a small set
    if (therapistView) {
      this.setState({ loading: true });
      api.get(`${process.env.REACT_APP_URL}/patients/therapist/${auth.username}?t=${Date.now()}`)
        .then(res => this.setState({ patients: res.data, loading: false, hasMore: false }))
        .catch(err => { console.error(err); this.setState({ loading: false }); });
    } else {
      this.setState({ loading: true });
      var url = `${process.env.REACT_APP_URL}/patients/profiles/page?skip=${skip}&limit=${pageLimit}&t=${Date.now()}`;
      if (sf) url += '&statsFilter=' + sf;
      api.get(url)
        .then(res => {
          const d = res.data;
          var newState = {
            patients: d.patients,
            totalPatients: d.filtered ? d.total : (d.total || d.patients.length),
            hasMore: false,
            loading: false,
          };
          // Only update aggregate stats from unfiltered responses
          if (!d.filtered) {
            newState.serverActiveNow = d.activeNow || 0;
            newState.serverOutstanding = d.outstandingTotal || 0;
            // Today granular
            newState.todayScheduled = d.todayScheduled || 0;
            newState.todayInProgress = d.todayInProgress || 0;
            newState.todayCompleted = d.todayCompleted || 0;
            newState.todayMissed = d.todayMissed || 0;
            // Week granular
            newState.weekScheduled = d.weekScheduled || 0;
            newState.weekCompleted = d.weekCompleted || 0;
            newState.weekMissed = d.weekMissed || 0;
            // Month granular
            newState.monthScheduled = d.monthScheduled || 0;
            newState.monthCompleted = d.monthCompleted || 0;
            newState.monthMissed = d.monthMissed || 0;
            // Date ranges for display
            if (d.dateRanges) newState.dateRanges = d.dateRanges;
          }
          this.setState(newState);
        })
        .catch(err => { console.error(err); this.setState({ loading: false }); });
    }

    api.get(`${process.env.REACT_APP_URL}/branches`)
      .then(res => this.setState({ branches: res.data }))
      .catch(console.error);

    // Fetch today's online appointments for badge
    const today = this.formatDate(new Date());
    api.get(`${process.env.REACT_APP_URL}/appointments?from=${today}&to=${today}`)
      .then(res => {
        const cards = new Set();
        (res.data || []).forEach(a => { if (a.isOnline && a.patientCard) cards.add(a.patientCard); });
        this.setState({ onlinePatientCards: cards });
      })
      .catch(() => {});
  };

  handleCdtPageChange = (newPage, perPage) => {
    const skip = (newPage - 1) * perPage;
    this.fetchData(skip, perPage);
  };

  handleCdtRowsPerPageChange = (newPerPage) => {
    this.rowsPerPage = newPerPage;
    this.fetchData(0, newPerPage);
  };

  // Check for updated data — stores new summary without applying it.
  // Shows a "refresh available" banner so the user can manually refresh.
  checkForUpdates = () => {
    const { auth, therapistView, patients } = this.state;
    if (!patients.length) return;

    const ur = therapistView ? `therapist/${auth.username}/summary` : 'profiles/summary';
    api.get(`${process.env.REACT_APP_URL}/patients/${ur}?t=${Date.now()}`)
      .then(res => {
        const summaryList = res.data || [];
        const summaryMap = {};
        summaryList.forEach(s => { summaryMap[s.patientCard] = s; });

        // Check if anything has actually changed
        const changed = patients.some(p => {
          const s = summaryMap[p.patientCard];
          if (!s) return false;
          return s.liveStatus !== p.liveStatus ||
                 s.status !== p.status ||
                 s.pendingvisits !== p.pendingvisits ||
                 s.overallStatusSoFar !== p.overallStatusSoFar ||
                 s.lastvisitdate !== p.lastvisitdate;
        });

        if (changed) {
          this.setState({ pendingSummary: summaryMap });
        }
      })
      .catch(console.error);
  };

  // Apply pending summary data to patients list (called by refresh button)
  applyPendingSummary = () => {
    const { pendingSummary } = this.state;
    if (!pendingSummary) return;

    this.setState(prev => ({
      pendingSummary: null,
      patients: prev.patients.map(p => {
        const s = pendingSummary[p.patientCard];
        if (!s) return p;
        return {
          ...p,
          pendingvisits:          s.pendingvisits,
          overallVisitCharges:    s.overallVisitCharges,
          lastvisitdate:          s.lastvisitdate,
          liveStatus:             s.liveStatus,
          overallStatusSoFar:     s.overallStatusSoFar,
          status:                 s.status,
          totalSoFar:             s.totalSoFar,
          totalPaidSoFar:         s.totalPaidSoFar,
          previousbalancedetails: s.previousbalancedetails,
          therapist:              s.therapist,
        };
      }),
    }));
  };

  // Direct refresh — fetches and applies immediately (used by visibility change + manual refresh)
  refreshSummary = () => {
    const { auth, therapistView, patients } = this.state;
    if (!patients.length) return;

    const ur = therapistView ? `therapist/${auth.username}/summary` : 'profiles/summary';
    api.get(`${process.env.REACT_APP_URL}/patients/${ur}?t=${Date.now()}`)
      .then(res => {
        const summaryMap = {};
        (res.data || []).forEach(s => { summaryMap[s.patientCard] = s; });

        this.setState(prev => ({
          pendingSummary: null,
          patients: prev.patients.map(p => {
            const s = summaryMap[p.patientCard];
            if (!s) return p;
            return {
              ...p,
              pendingvisits:          s.pendingvisits,
              overallVisitCharges:    s.overallVisitCharges,
              lastvisitdate:          s.lastvisitdate,
              liveStatus:             s.liveStatus,
              overallStatusSoFar:     s.overallStatusSoFar,
              status:                 s.status,
              totalSoFar:             s.totalSoFar,
              totalPaidSoFar:         s.totalPaidSoFar,
              previousbalancedetails: s.previousbalancedetails,
              therapist:              s.therapist,
            };
          }),
        }));
      })
      .catch(console.error);
  };

  

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => {
      const target = prevState.isEditMode ? { ...prevState.selectedPatient } : { ...prevState.newPatient };
      target[name] = value;
      return prevState.isEditMode ? { selectedPatient: target } : { newPatient: target };
    });
  };

  handleDateChange = (e) => {
    const { value } = e.target;
    this.setState(prevState => {
      const target = prevState.isEditMode ? { ...prevState.selectedPatient } : { ...prevState.newPatient };
      target.registrationDate = value;
      return prevState.isEditMode ? { selectedPatient: target } : { newPatient: target };
    });
  };

  setMyCheckbox = (isChecked, group, key) => {
    this.setState(prevState => {
      const target = prevState.isEditMode ? { ...prevState.selectedPatientNow } : { ...prevState.newPatientNow };
      target[key] = isChecked;
      return prevState.isEditMode ? { selectedPatientNow: target } : { newPatientNow: target };
    });
  };

 
  handleImageCaptured = (imageData) => {
    var target = this.state.isEditMode ? 'selectedPatient' : 'newPatient';
    var updated = Object.assign({}, this.state[target], { pic: imageData });
    this.setState({ showCamera: false, [target]: updated });
  }

  setShowCamera = (val) => {
    this.setState({ showCamera: val });
  }

  handleAddNewPatient = () => {
    const np = this.emptyPatient();
    // Override branch with latest branch from fetched data (constructor runs before fetch)
    const latestBranch = this.getLatestBranch();
    if (latestBranch) np.branch = latestBranch;
    this.setState({
      isModalOpen: true,
      isEditMode: false,
      modalData: null,
      hasModalChanged: false,
      selectedPatient: null,
      newPatient: np,
      newPatientNow: this.emptyNow()
    }, () => {
      // Auto-generate card number after state is set (branch defaults to latest added branch)
      this.autogenerateHealthId();
    });
  };

  handleClose = () => {
    this.setState({
      isModalOpen: false,
      isEditMode: false,
      modalData: null,
      selectedPatient: null
    }, this.fetchData);
  };

  handleFieldChange = (field, value) => {
  if (this.state.isEditMode) {
    this.setState(prevState => ({
      selectedPatient: {
        ...prevState.selectedPatient,
        [field]: value,
      },
    }));
  } else {
    this.setState(prevState => ({
      newPatient: {
        ...prevState.newPatient,
        [field]: value,
      },
    }), () => {
      // Re-generate card number when branch changes
      if (field === 'branch') this.autogenerateHealthId();
    });
  }
  };
  handleCheckboxChange = (field, key, checked) => {
    if (this.state.isEditMode) {
      this.setState(prevState => ({
        selectedPatient: {
          ...prevState.selectedPatient,
          [field]: {
            ...prevState.selectedPatient[field],
            [key]: checked,
          },
        },
      }));
    } else {
      this.setState(prevState => ({
        newPatient: {
          ...prevState.newPatient,
          [field]: {
            ...prevState.newPatient[field],
            [key]: checked,
          },
        },
      }));
    }
  };

handleAddPatient = (e) => {
  e.preventDefault();
  const np = { ...this.state.newPatient }; // copy — never mutate state directly
  if (!np.patientCard || !np.branch || np.branch === "selectB") {
    this.showAppAlert('Please fill all required fields: PatientCard / Branch', 'warning');
    return;
  }
  if (!np.name || !np.number) {
    this.showAppAlert('Name and Contact Number are required', 'warning');
    return;
  }
  var ba = this.state.branches.find(b => b.name === np["branch"]);
  if (!ba) {
    this.showAppAlert('Selected branch not found. Please refresh and try again.', 'error');
    return;
  }
  np["patientCard"] = ba.acr + np["patientCard"].replace(new RegExp('^(' + ba.acr + ')+', 'i'), '');
  console.log("newpatient = ", np);

  const picData = np.pic; // base64 or null
  const photoFile = this.state.photoFile; // File object from file input
  delete np.pic; // don't send base64 in JSON body

  api.post(`${process.env.REACT_APP_URL}/patients/profiles/add/${np.patientCard}`, np)
    .then(async (res) => {
      const savedPatient = res.data;
      // Upload photo to Drive (compressed + encrypted) if available
      if (picData || photoFile) {
        try {
          const fd = new FormData();
          if (photoFile) {
            fd.append('photo', photoFile);
          } else if (picData) {
            // Convert base64 to blob
            const resp = await fetch(picData);
            const blob = await resp.blob();
            fd.append('photo', blob, `${np.patientCard}.jpg`);
          }
          const photoRes = await api.post(
            `${process.env.REACT_APP_URL}/patient-files/${np.patientCard}/photo`,
            fd, { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          savedPatient.pic = photoRes.data.url;
        } catch (photoErr) {
          console.error('Photo upload failed:', photoErr);
          this.showAppAlert('Patient added but photo upload failed', 'warning');
        }
      }
      this.showAppAlert(`Patient ${np.patientCard} added successfully!`, 'success');
      this.setState(prevState => ({
        patients: [...prevState.patients, savedPatient],
        newPatient: this.emptyPatient(),
        photoFile: null,
        isModalOpen: false
      }));
    })
   .catch(error => {
      const msg =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        "An unknown error occurred";
      this.showAppAlert(typeof msg === 'string' ? msg : JSON.stringify(msg), 'error');
   });

};

handleAddWithConsultationBill = async () => {
  const np = { ...this.state.newPatient };
  if (!np.patientCard || !np.branch || np.branch === 'selectB') {
    this.showAppAlert('Please fill all required fields: PatientCard / Branch', 'warning');
    return;
  }
  if (!np.name || !np.number) {
    this.showAppAlert('Name and Contact Number are required', 'warning');
    return;
  }
  var ba = this.state.branches.find(b => b.name === np.branch);
  if (!ba) {
    this.showAppAlert('Selected branch not found. Please refresh and try again.', 'error');
    return;
  }
  np.patientCard = ba.acr + np.patientCard.replace(new RegExp('^(' + ba.acr + ')+', 'i'), '');

  const picData = np.pic;
  const photoFile = this.state.photoFile;
  delete np.pic;

  try {
    // 1. Create patient
    const res = await api.post(`${process.env.REACT_APP_URL}/patients/profiles/add/${np.patientCard}`, np);
    const savedPatient = res.data;

    // Upload photo if available
    if (picData || photoFile) {
      try {
        const fd = new FormData();
        if (photoFile) { fd.append('photo', photoFile); }
        else if (picData) { const r = await fetch(picData); const blob = await r.blob(); fd.append('photo', blob, `${np.patientCard}.jpg`); }
        const photoRes = await api.post(`${process.env.REACT_APP_URL}/patient-files/${np.patientCard}/photo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        savedPatient.pic = photoRes.data.url;
      } catch (e) { console.error('Photo upload failed:', e); }
    }

    // 2. Find consultation service
    const svcRes = await api.get(`${process.env.REACT_APP_URL}/services`);
    const allServices = svcRes.data || [];
    const consultSvc = allServices.find(s =>
      s.name && s.name.toLowerCase().includes('consult') && s.org === 'MedicalyogaTherapyCentre'
    );
    if (!consultSvc) {
      this.showAppAlert('Patient added but no Consultation service found. Please bill manually.', 'warning');
      this.setState(prev => ({ patients: [...prev.patients, savedPatient], newPatient: this.emptyPatient(), photoFile: null, isModalOpen: false }));
      return;
    }

    // 3. Create consultation bill
    const svcAmount = Number(consultSvc.amount || 0);
    const svcQty = 1;
    const total = svcAmount * svcQty;
    const bill = {
      branch: np.branch,
      billorg: consultSvc.org || 'MedicalyogaTherapyCentre',
      patientCard: np.patientCard,
      name: np.name,
      number: np.number,
      patientBranch: np.branch,
      invoicenumber: 'INV-' + Date.now(),
      invoicedate: new Date(),
      sgst: Number(consultSvc.sgst || 0),
      cgst: Number(consultSvc.cgst || 0),
      igst: Number(consultSvc.igst || 0),
      ecess: Number(consultSvc.ecess || 0),
      discount: 0,
      total: total,
      paid: total,
      txnid: 'TXN-' + Date.now(),
      balance: 0,
      givenback: 0,
      paymentmode: 'Cash',
      status: 'paid',
      services: [{
        name: consultSvc.name,
        amount: svcAmount,
        qty: svcQty,
        org: consultSvc.org || 'MedicalyogaTherapyCentre',
        sgst: Number(consultSvc.sgst || 0),
        cgst: Number(consultSvc.cgst || 0),
        igst: Number(consultSvc.igst || 0),
        ecess: Number(consultSvc.ecess || 0),
      }],
      comments: 'Consultation with Dr. Deepak - auto-billed at registration',
    };

    await api.post(`${process.env.REACT_APP_URL}/billings/add/${np.patientCard}`, bill);
    this.showAppAlert('Patient added & consultation billed successfully!', 'success');

    this.setState(prev => ({
      patients: [...prev.patients, { ...savedPatient, status: 'enrolled', totalSoFar: total, totalPaidSoFar: total }],
      newPatient: this.emptyPatient(),
      photoFile: null,
      isModalOpen: false,
    }));
  } catch (error) {
    const raw = error.response?.data?.message || error.response?.data || error.message || 'An unknown error occurred';
    this.showAppAlert(typeof raw === 'string' ? raw : JSON.stringify(raw), 'error');
  }
};

handleUpdatePatient = (e) => {
  //e.preventDefault();
  const sp = this.state.selectedPatient;
  const id = sp._id;
  const photoFile = this.state.photoFile;
  const picIsBase64 = sp.pic && sp.pic.startsWith('data:');

  api.post(`${process.env.REACT_APP_URL}/patients/profiles/update/${id}`, sp)
    .then(async () => {
      // Upload new photo to Drive if changed (base64 from camera or file input)
      if (photoFile || picIsBase64) {
        try {
          const fd = new FormData();
          if (photoFile) {
            fd.append('photo', photoFile);
          } else {
            const resp = await fetch(sp.pic);
            const blob = await resp.blob();
            fd.append('photo', blob, `${sp.patientCard}.jpg`);
          }
          await api.post(
            `${process.env.REACT_APP_URL}/patient-files/${sp.patientCard}/photo`,
            fd, { headers: { 'Content-Type': 'multipart/form-data' } }
          );
        } catch (photoErr) {
          console.error('Photo upload failed:', photoErr);
        }
      }
      this.setState({ photoFile: null });
      this.handleClose();
    })
    .catch(error => {
  const msg =
    error.response?.data?.message || // Custom backend error
    error.response?.data ||          // Sometimes it's a plain string
    error.message ||                 // Axios error message
    "An unknown error occurred";

  this.showAppAlert(msg, 'error');
});

};

  handleDeletePatient = (id) => {
    const patientToDelete = this.state.patients.find(p => p._id === id);
    if (!patientToDelete) return;
    this.showAppConfirm("Are you sure you want to delete this Entry ?", () => {
      api.delete(`${process.env.REACT_APP_URL}/patients/profiles/delete/${patientToDelete.patientCard}`)
        .then(() => {
          this.setState(prevState => ({
            patients: prevState.patients.filter(p => p._id !== id)
          }));
        })
        .catch(error => {
          const msg =
            error.response?.data?.message ||
            error.response?.data ||
            error.message ||
            "An unknown error occurred";
          this.showAppAlert(msg, 'error');
        });
    });

  };

handleEditPatient = (id) => {

  const pt = this.state.patients.find(p => p._id === id);
  
  if (!pt) return;

  // ensure now is always present (avoid undefined)
  this.setState({
    selectedPatient: {
      ...pt,
      now: pt.now || this.emptyNow(),
    },
    isEditMode: true,
    isModalOpen: true,
    hasModalChanged: false,
  });
};


  handlePatientDetails = (pt) => {
    const isTherapist = !!this.state.therapistView;
    // const { therapistView } = this.state;
    console.log("handlePatientDetails -- patient = pt = ", pt);
    
    sessionStorage.removeItem("PCData");
    sessionStorage.setItem("PCData", JSON.stringify(pt));

    if (this.state.therapistView !== "") {
      this.setState({
        selectedPatient: pt,
        isModalOpen: true,
        hasModalChanged: true,
        modalData: pt,
        tabToSelect: '',
        // Optionally, you could reset isEditMode if needed here
        // isEditMode: false,
      });
      console.log("modalData in render", this.state.modalData);
    }
    else
    {
      this.setState({
        selectedPatient: pt, //null,
        isEditMode: false,  // Switch to Add mode
        isModalOpen: true,
        hasModalChanged: true,
        modalData: pt,
        tabToSelect: '',
      });
    }
  console.log("modalData in render", this.state.modalData);

};

  autogenerateHealthId = async () => {
    const { newPatient, branches } = this.state;
    const br = newPatient.branch;
    const branchObj = branches.find(b => b.name === br);

    if (!branchObj) {
      alert('Select branch');
      return;
    }

    const prefix = branchObj.acr;

    try {
      // Query backend for the next available card ID (scans ALL patients, not just paginated)
      const res = await api.get(`${process.env.REACT_APP_URL}/patients/next-card/${prefix}`);
      const nextCard = res.data.nextCard;
      this.setState({ newPatient: { ...this.state.newPatient, patientCard: nextCard } });
    } catch (err) {
      console.error('Failed to fetch next card ID:', err);
      // Fallback: generate locally from loaded patients
      const filtered = this.state.patients.filter(p =>
        p.patientCard && p.patientCard.startsWith(prefix)
      );
      let maxNum = 0;
      filtered.forEach(p => {
        const match = p.patientCard.match(/\d{6}$/);
        if (match) {
          const num = parseInt(match[0], 10);
          if (num > maxNum) maxNum = num;
        }
      });
      const newId = `${prefix}${String(maxNum + 1).padStart(6, '0')}`;
      this.setState({ newPatient: { ...this.state.newPatient, patientCard: newId } });
    }
  };

  
  autogenerateHealthIdOld = () => {
    const { newPatient, branches, patients } = this.state;
    const br = newPatient.branch;
    const branchObj = branches.find(b => b.name === br);

    if (!branchObj) {
      alert('Select branch');
      return;
    }

    const existing = patients.filter(p => p.patientCard.includes('_CL_') && p.branch === br);
    let num = (existing.length + 1).toString().padStart(6, '0');
    const newId = `${branchObj.acr}_CL_${num}`;
    this.setState({ newPatient: { ...newPatient, patientCard: newId } });
  };

  handleFilterChange = (key, value) => {
    this.setState(prevState => ({
      filters: { ...prevState.filters, [key]: value }
    }));
  };

  moveToSession = (row) => {
    
    this.setState(prevState => ({
      ...prevState,
      tabToSelect: "PatientSequences",
      isModalOpen: true,
      hasModalChanged: true,
      modalData: row,
    }));
  };

  
scheduleAppointment = (appt, newStart) => {
  if (!newStart || isNaN(new Date(newStart).getTime())) {
    alert("Invalid appointment date");
    return;
  }
  console.log("appt ==> ", appt);
  const startDate = new Date(newStart);

  // End time = start + planned exercise duration (50 min default if no exercises)
  const durMin = (this.state.schedulePlannedDuration || 50);
  const endDate = new Date(startDate.getTime() + durMin * 60 * 1000);
  const auth = this.state.auth;

  const newAppointment = {
    ...appt,
    therapist: auth.username,
    start: startDate,
    end: endDate,
    date: startDate,      // backend queries depend on this
    isToday: false,
    patientCard: appt.patientCard,
    username: auth.username, // therapist
    title: appt.name, // patient
    type: "Therapy",
    handoverTo: auth.username,
    handoverFrom: auth.username,
    status: "scheduled",
    isOnline: this.state.isOnlineSchedule,
  };

  delete newAppointment._id;
  delete newAppointment.__v;

  api
    .post(`${process.env.REACT_APP_URL}/appointments/dynamic/add`, newAppointment)
    .then(() => {
      alert("✅ Appointment scheduled!");
      this.closeModal();
      
      // -----------------------------
      // WhatsApp Message
      // -----------------------------
      const [namePart, numberPart] = (appt.title || "")
        .split("/")
        .map((s) => s.trim());

      const phoneNumber = numberPart ? numberPart.replace(/\D/g, "") : "";

      const formatted = startDate.toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const message = `Namastey ${namePart} Ji, your appointment is scheduled on ${formatted}.`;

      /*
      if (phoneNumber) sendWhatsAppMsg(phoneNumber, message);
      else window.alert("No phone number provided for WhatsApp message.");
      */
    })
    .catch((err) => {
      console.error("Error scheduling:", err);
      this.showAppAlert(`❌ Error scheduling appointment. ${err}`, 'error');
    });
};

    openScheduleModal = async (row) => {
      console.log("open ", row);
      const [tomappointments, seqsRes] = await Promise.all([
        api.get(`${process.env.REACT_APP_URL}/appointments/type/Therapy/patient/${row.patientCard}?_=${new Date().getTime()}`),
        api.get(`${process.env.REACT_APP_URL}/patients/consultation/patientsequences/${row.patientCard}?t=${Date.now()}`).catch(() => ({ data: null })),
      ]);

      const allAppointments = tomappointments.data.map((appt) => ({
        ...appt,
        start: new Date(appt.start || appt.date),
        end: new Date(appt.end),
      }));

      const seqs = seqsRes.data?.sequences || [];
      const plannedDuration = seqs.reduce((sum, ex) => sum + (ex.duration ?? 1) * (ex.repetition ?? 1), 0) || 50;

      this.setState(prevState => ({
        ...prevState,
        allappointments: allAppointments,
        showScheduleModal: true,
        selectedAppt: row,
        futureDate: new Date(),
        schedulePlannedDuration: plannedDuration,
      }));
    };

  closeModal = () => {
    this.setState(prevState => ({
      ...prevState,
      showScheduleModal: false,
      showDatePicker: false,
      selectedAppt: null,
      futureDate: null,
      schedulePlannedDuration: 50,
    }));
  };

   moveToBilling = (row, data1) => {
    
    this.handleClose();
    const data = this.billingdata(row, data1);
    
    const patientCard = row.patientCard;
    
    this.props.navigate('/Billing', {
      state: {
        statedata: {
          patientCard,
          dets: data.dets,
          patientCData: row,
        }
      }
    });
  };
  
getpreviousOutstandingWithOrgs = (row) => {
  if (!row) return {bal: 0, dets: []};

  var dets = row?.previousbalancedetails || [];
  var total = 0;
  var orgs = [];
  var j =0;
  for (var i=0; i< dets.length; i++)
  {
       total += Number((Number(dets[i]?.balance || 0)).toFixed(2));
       orgs.push (dets[i].org);
       if (Number(dets[i]?.balance || 0).toFixed(2) > 0)
        dets[i]["filter"] = "pending";
       else if (Number(dets[i]?.balance || 0).toFixed(2) < 0)
        dets[i]["filter"] = "refund";
       else
        j++;
  }

  // Add unbilled session fees: sessions completed but not yet included in any formal bill
  const unbilledFees = Math.max(0, (row.overallVisitCharges || 0) - (row.totalSoFar || 0));
  total += unbilledFees;

  if (j == dets.length) dets= [];
  return {bal: total, dets:dets};
}


  billingdata = (row, data) => {
    let { status, overallStatusSoFar: ostatus, pendingvisits: pv, totalSoFar, totalPaidSoFar } = row;
    let bal =0; 
    let dets = [];
    //if (!data) data = this.getpreviousOutstandingWithOrgs(row);//(totalSoFar ?? 0) - (totalPaidSoFar ?? 0);

    bal = data.bal;
    dets = data.dets;

    if (pv !== undefined) {
      if (pv <= 0) status = 'Session Renewal';
      else if (pv <= 5) status = 'Session Check';
    }

    if (status === 'enrolled' && ostatus && ostatus !== 'ok') {
      status = ostatus;
      //console.log("ostatus = ", ostatus);
    }
    const { isOwner } = this.state;
    //console.log("balance = ",bal);
    const statusMap = {
      'Payment Pending': ["pending",  bal.toString(), 'red'],
      'Credit Balance': ['credit',  bal.toString(), 'green'],
      'Session Renewal': ['renew', 'Renew', 'purple'],    
    };

    let [op = '', label = status || '', color = 'gray'] = statusMap[status] || [];
    let label1 = bal;
    let op1 =    bal > 0 ? "pending" :
                 bal < 0 ? "credit"  :
                      "settled";
    return {"op": op1, amount: label1, patientCData: row, dets: dets};
  };

  getNextActionText = (row) => {
    let { status, overallStatusSoFar: ostatus, pendingvisits: pv } = row;
    if (status === 'enrolled' && pv !== undefined) {
      if (pv <= 0) return 'Renew';
      if (pv <= 5) return `${pv} Left`;
    }
    if (status === 'enrolled' && ostatus && ostatus !== 'ok') status = ostatus;
    const map = { registered:'Consultation', provisional:'Pre-Consult', consultation:'Post-Consult',
      postconsultation:'Billing', enrolled:'Active', ok:'Active', Hold:'On Hold',
      'Payment Pending':'Payment Due', 'Credit Balance':'Credit', 'Session Renewal':'Renew' };
    return map[status] || status || '—';
  };

  getLiveStatusText = (row) => {
    let { liveStatus, lastvisitdate } = row;
    if (liveStatus && lastvisitdate) {
      const lv = new Date(lastvisitdate), t = new Date();
      if (lv.getFullYear() !== t.getFullYear() || lv.getMonth() !== t.getMonth() || lv.getDate() !== t.getDate()) return '—';
    }
    const map = { InTherapySession:'In Session', AtReception:'Reception', InConsultation:'Consulting',
      InUltraSonic:'UltraSonic', InPhysio:'Physio', InOnlineSession:'Online',
      FinishedTherapySession:'Done', SkippedTherapySession:'Skipped' };
    return map[liveStatus] || '—';
  };

  getNextActionTooltip = (row) => {
    const { status, overallStatusSoFar: ostatus, pendingvisits: pv, totalSoFar, totalPaidSoFar, lastvisitdate, name } = row;
    const lines = [name || row.patientCard || ''];
    lines.push(`Status: ${status || '—'}`);
    if (ostatus && ostatus !== 'ok') lines.push(`Financial: ${ostatus}`);
    if (pv !== undefined) lines.push(`Sessions remaining: ${pv}`);
    if (totalSoFar !== undefined) lines.push(`Total charges: ₹${Number(totalSoFar) || 0}`);
    if (totalPaidSoFar !== undefined) lines.push(`Total paid: ₹${Number(totalPaidSoFar) || 0}`);
    const bal = (Number(totalSoFar) || 0) - (Number(totalPaidSoFar) || 0);
    if (totalSoFar !== undefined && totalPaidSoFar !== undefined) {
      lines.push(bal > 0 ? `Outstanding: ₹${bal}` : bal < 0 ? `Credit: ₹${Math.abs(bal)}` : 'Balance: Settled');
    }
    if (lastvisitdate) lines.push(`Last visit: ${new Date(lastvisitdate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' })}`);
    // Why this action
    if (status === 'enrolled' && pv !== undefined && pv <= 0) lines.push('→ All purchased sessions used, needs renewal');
    else if (status === 'enrolled' && pv !== undefined && pv <= 5) lines.push(`→ ${pv} session${pv > 1 ? 's' : ''} left from package`);
    else if (status === 'enrolled' && ostatus === 'Payment Pending') lines.push('→ Outstanding balance, payment due');
    else if (status === 'enrolled' && ostatus === 'Credit Balance') lines.push('→ Overpaid, has credit balance');
    else if (status === 'enrolled' && ostatus === 'Hold') lines.push('→ Sessions on hold');
    else if (status === 'registered') lines.push('→ Registered, awaiting first consultation');
    else if (status === 'provisional') lines.push('→ Pre-consultation stage');
    else if (status === 'consultation') lines.push('→ Consultation done, awaiting post-consult actions');
    else if (status === 'postconsultation') lines.push('→ Post-consultation complete, needs billing');
    else if (status === 'enrolled') lines.push('→ Active and up to date');
    return lines.join('\n');
  };

  renderNextActionCell = (row) => {
    let { status, overallStatusSoFar: ostatus, pendingvisits: pv } = row;

    // Pending visits overlay — only for enrolled patients (not pre-billing stages)
    if (status === 'enrolled' && pv !== undefined) {
      if (pv <= 0) status = 'Session Renewal';
      else if (pv <= 5) status = 'Session Check';
    }

    // Financial overlay — enrolled patients with outstanding balance
    if (status === 'enrolled' && ostatus && ostatus !== 'ok') {
      status = ostatus;
    }

    const statusMap = {
      registered:        { label: 'Consultation',       bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' },
      provisional:       { label: 'Pre-Consult',        bg: '#f8fafc', color: '#64748b', border: '#e2e8f0' },
      consultation:      { label: 'Post-Consult',       bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
      postconsultation:  { label: 'Billing',            bg: '#f5f3ff', color: '#6d28d9', border: '#ddd6fe' },
      enrolled:          { label: 'Active',             bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0' },
      ok:                { label: 'Active',             bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0' },
      Hold:              { label: 'On Hold',            bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
      'Payment Pending': { label: 'Payment Due',        bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
      'Credit Balance':  { label: 'Credit',             bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0' },
      'Session Renewal': { label: 'Renew',              bg: '#faf5ff', color: '#7c3aed', border: '#ddd6fe' },
      'Session Check':   { label: `${pv} Left`,         bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' },
    };

    const s = statusMap[status] || { label: status || '—', bg: '#f8fafc', color: '#64748b', border: '#e2e8f0' };
    const tooltip = this.getNextActionTooltip(row);

    const refDate = row.lastvisitdate || row.registrationDate;
    let inactiveDays = 0;
    if (refDate) {
      inactiveDays = Math.floor((Date.now() - new Date(refDate).getTime()) / 86400000);
    }
    const isStale = inactiveDays >= 30;

    const badgeBg = isStale ? '#f3f4f6' : s.bg;
    const badgeColor = isStale ? '#9ca3af' : s.color;
    const badgeBorder = isStale ? '#e5e7eb' : s.border;

    const canSeeBills = canDo(this.state.auth, 'billing.view');
    const total = Number(row.totalSoFar) || 0;
    const paid = Number(row.totalPaidSoFar) || 0;
    const pending = total - paid;
    const isSessionCheck = status === 'Session Check';
    const showAmounts = canSeeBills && (status === 'Payment Pending' || status === 'Credit Balance' || isSessionCheck);

    if (showAmounts) {
      return (
        <div title={tooltip} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, lineHeight: 1.3 }}>
          {isSessionCheck && (
            <span style={{
              display: 'inline-block', padding: '2px 8px', borderRadius: 6,
              fontSize: 11, fontWeight: 700, background: badgeBg, color: badgeColor,
              border: `1px solid ${badgeBorder}`, marginBottom: 2,
            }}>{pv} Left</span>
          )}
          <span style={{ fontSize: 10, color: '#64748b' }}>Total: <b style={{ color: '#334155' }}>₹{total.toLocaleString('en-IN')}</b> | Paid: <b style={{ color: '#15803d' }}>₹{paid.toLocaleString('en-IN')}</b></span>
          {pending !== 0 && (
            <span style={{ fontSize: 10, fontWeight: 700, color: pending > 0 ? '#dc2626' : '#15803d' }}>
              {pending > 0 ? `Pending ₹${pending.toLocaleString('en-IN')}` : `Credit ₹${Math.abs(pending).toLocaleString('en-IN')}`}
            </span>
          )}
          {isStale && <span style={{ fontSize: 9, color: '#dc2626', fontWeight: 600 }}>inactive {inactiveDays}d</span>}
        </div>
      );
    }

    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
        <span title={tooltip} style={{
          display: 'inline-block',
          padding: '4px 12px',
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.02em',
          background: badgeBg,
          color: badgeColor,
          border: `1px solid ${badgeBorder}`,
          whiteSpace: 'nowrap',
          cursor: 'default',
        }}>{s.label}</span>
        {isStale && (
          <span style={{ fontSize: 9, color: '#dc2626', fontWeight: 600, marginTop: 2, whiteSpace: 'nowrap' }}>
            inactive {inactiveDays}d
          </span>
        )}
      </div>
    );
  };
  
extractTextFromNode = (node) => {
  if (node === null || node === undefined || node === false) return "";

  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map(n => this.extractTextFromNode(n)).join(" ");
  }

  if (typeof node === "object") {
    if (node.props && node.props.children !== undefined) {
      return this.extractTextFromNode(node.props.children);
    }
    if (node.children !== undefined) {
      return this.extractTextFromNode(node.children);
    }
    return "";
  }

  return "";
}

hasNumber = (node) => {
  const text = this.extractTextFromNode(node);
  return /\d/.test(text);
}


  renderLiveStatusCell = (row) => {
    let { liveStatus, lastvisitdate } = row;

    // Only show live status if lastvisitdate is today — stale statuses from previous days are meaningless
    if (liveStatus && lastvisitdate) {
      const lastVisit = new Date(lastvisitdate);
      const today = new Date();
      const isToday = lastVisit.getFullYear() === today.getFullYear()
        && lastVisit.getMonth() === today.getMonth()
        && lastVisit.getDate() === today.getDate();
      if (!isToday) liveStatus = null;
    }

    const statusMap = {
      InTherapySession:        { dot: '#22c55e', label: 'In Session',   pulse: true },
      AtReception:             { dot: '#eab308', label: 'Reception',    pulse: true },
      InConsultation:          { dot: '#3b82f6', label: 'Consulting',   pulse: true },
      InUltraSonic:            { dot: '#a855f7', label: 'UltraSonic',   pulse: true },
      InPhysio:                { dot: '#f97316', label: 'Physio',       pulse: true },
      InOnlineSession:         { dot: '#8b5cf6', label: 'Online',       pulse: true },
      FinishedTherapySession:  { dot: '#6b7280', label: 'Done',         pulse: false },
      SkippedTherapySession:   { dot: '#ef4444', label: 'Skipped',      pulse: false },
    };

    const s = statusMap[liveStatus];
    if (!s) return <span style={{ color: '#cbd5e1', fontSize: 12 }}>—</span>;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
        <span style={{
          width: 8, height: 8, borderRadius: '50%',
          background: s.dot, flexShrink: 0,
          boxShadow: s.pulse ? `0 0 0 3px ${s.dot}33` : 'none',
          animation: s.pulse ? 'pulse-dot 2s infinite' : 'none',
        }} />
        <span style={{ fontSize: 12, fontWeight: 600, color: '#334155' }}>{s.label}</span>
      </div>
    );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.isEditMode) {
      this.handleUpdatePatient(this.state.selectedPatient._id, e);
    } else {
      this.handleAddPatient(e);
    }
  }

  renderTabButton = (key, label) => {
    const active = this.state.activeTab === key;

    return (
      <button
        onClick={() => this.setState({ activeTab: key })}
        style={{
          padding: '12px 22px',
          border: 'none',
          cursor: 'pointer',
          background: 'none',
          borderBottom: active ? '2.5px solid #1d4ed8' : '2.5px solid transparent',
          color: active ? '#1d4ed8' : '#94a3b8',
          fontSize: 13,
          fontWeight: 700,
          marginRight: 4,
          transition: 'all 0.15s',
          fontFamily: "'Inter','SF Pro Display',system-ui,sans-serif",
        }}
      >
        {label}
      </button>
    );
  };

  render = () => {
  const {
    patients,
    filters,
    modalData,
    therapistView,
    hasModalChanged,
    selectedPatient,
    isModalOpen,
    isEditMode,
    newPatient,
    branches,
    tabToSelect,
    isOwner,
    canSeeOutstanding
  } = this.state;
  const roles = this.state.auth.roles;
  var sp = selectedPatient;
  var np = newPatient;
  const patient = this.state.isEditMode ? this.state.selectedPatient : this.state.newPatient;
  
  const inputStyle = {
    width: '100%',
    padding: '11px 14px',
    borderRadius: 10,
    border: '1.5px solid #e2e8f0',
    fontSize: 14,
    color: '#0f172a',
    background: '#fff',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    fontFamily: "'Inter','SF Pro Display',system-ui,sans-serif",
  };
  const labelStyle = {
    display: 'block', marginBottom: 6, fontSize: 11, fontWeight: 700,
    color: '#475569', textTransform: 'uppercase', letterSpacing: '0.06em',
    fontFamily: "'Inter','SF Pro Display',system-ui,sans-serif",
  };

  const tableCols = [
               {
                name: 'Card',
                selector: (row) => row.patientCard,
                cell: (row) => <span style={{ fontSize: 12, fontWeight: 600, color: '#475569', letterSpacing: '0.02em' }}>{row.patientCard}</span>,
                sortable: true,
              },
              {
                name: 'Name',
                selector: (row) => row.name,
                cell: (row) => (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {this.state.onlinePatientCards.has(row.patientCard) && (
                      <span title="Online appointment today" style={{
                        background: '#dbeafe', color: '#1d4ed8', fontSize: 8, fontWeight: 800,
                        padding: '1px 4px', borderRadius: 4, lineHeight: 1.3, whiteSpace: 'nowrap',
                      }}>ON</span>
                    )}
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        this.handlePatientDetails(row);
                      }}
                      style={{ cursor: 'pointer', color: '#1d4ed8', fontWeight: 700, fontSize: 13, letterSpacing: -0.2 }}
                    >
                      {row.name}
                    </span>
                  </div>
                ),
                sortable: true,
              },

              {
                name: 'Contact',
                selector: (row) => row.number,
                cell: (row) => <span style={{ fontSize: 12, color: '#334155', fontWeight: 500 }}>{row.number}</span>,
                sortable: true,
              },
              {
                name: 'C/P/PP/U/B/R',
                selector: (row) => row._completedSessions || 0,
                cell: (row) => {
                  const ct = row._completedByType || { doctor: 0, senior: 0, therapist: 0 };
                  const pt = row._paidByType || { doctor: 0, senior: 0, therapist: 0 };
                  const ppt = row._ppByType || { doctor: 0, senior: 0, therapist: 0 };
                  const ut = row._unpaidByType || { doctor: 0, senior: 0, therapist: 0 };
                  const bt = row._boughtByType || { doctor: 0, senior: 0, therapist: 0 };
                  const rt = row._recommendedByType || { doctor: 0, senior: 0, therapist: 0 };
                  const c = row._completedSessions || 0;
                  const p = row._paidSessions || 0;
                  const pp = row._ppSessions || 0;
                  const u = row._unpaidSessions || 0;
                  const b = row._boughtSessions || 0;
                  const r = row._recommendedSessions || 0;
                  if (c === 0 && b === 0 && r === 0) return <span style={{ color: '#cbd5e1', fontSize: 9 }}>—</span>;
                  const mono = { fontFamily: "'SF Mono','Menlo',monospace", letterSpacing: -0.3 };
                  const title = `C=Completed P=Paid PP=PartiallyPaid U=Unpaid B=Bought R=Recommended\n` +
                    `Total: ${c}C ${p}P ${pp}PP ${u}U ${b}B ${r}R\n` +
                    `Doctor: ${ct.doctor}C ${pt.doctor}P ${ppt.doctor}PP ${ut.doctor}U ${bt.doctor}B ${rt.doctor}R\n` +
                    `Sr.Th: ${ct.senior}C ${pt.senior}P ${ppt.senior}PP ${ut.senior}U ${bt.senior}B ${rt.senior}R\n` +
                    `Th: ${ct.therapist}C ${pt.therapist}P ${ppt.therapist}PP ${ut.therapist}U ${bt.therapist}B ${rt.therapist}R`;
                  // Header row style
                  const cols = '20px 16px 16px 16px 16px 16px 16px';
                  const hdr = { display: 'grid', gridTemplateColumns: cols, gap: 1, fontSize: 8, color: '#94a3b8', fontWeight: 700, letterSpacing: 0.2, marginBottom: 1 };
                  const dataRow = { display: 'grid', gridTemplateColumns: cols, gap: 1, fontSize: 10, fontWeight: 700, lineHeight: 1.3 };
                  const v = (val, color) => <span style={{ textAlign: 'center', color: val > 0 ? color : '#e2e8f0' }}>{val}</span>;
                  const typeRow = (label, key) => {
                    if (ct[key] === 0 && bt[key] === 0 && rt[key] === 0) return null;
                    return (
                      <div key={key} style={dataRow}>
                        <span style={{ color: '#64748b', fontSize: 9 }}>{label}</span>
                        {v(ct[key], '#2e7d32')}{v(pt[key], '#0d9488')}{v(ppt[key], '#d97706')}{v(ut[key], '#d32f2f')}{v(bt[key], '#1565c0')}{v(rt[key], '#7b1fa2')}
                      </div>
                    );
                  };
                  return (
                    <div title={title} style={mono}>
                      <div style={hdr}>
                        <span></span>
                        <span style={{ textAlign: 'center', color: '#2e7d32' }}>C</span>
                        <span style={{ textAlign: 'center', color: '#0d9488' }}>P</span>
                        <span style={{ textAlign: 'center', color: '#d97706' }}>PP</span>
                        <span style={{ textAlign: 'center', color: '#d32f2f' }}>U</span>
                        <span style={{ textAlign: 'center', color: '#1565c0' }}>B</span>
                        <span style={{ textAlign: 'center', color: '#7b1fa2' }}>R</span>
                      </div>
                      {typeRow('Dr', 'doctor')}
                      {typeRow('Sr', 'senior')}
                      {typeRow('Th', 'therapist')}
                    </div>
                  );
                },
                sortable: true,
                width: '160px',
              },
           
           
            ];

  if (isOwner)
  {
    tableCols.push(
              {
                name: 'Next Action',
                selector: (row) => this.getNextActionText(row),
                cell: (row) => this.renderNextActionCell(row),
              },
              // 'Live' column hidden to give more space to C/P/PP/B/R
              {
                name: 'Therapist',
                selector: (row) => row.therapist,
                cell: (row) => row.therapist,
                sortable: true,
                omit: (!this.state.isOwner),
              },
            )};

            tableCols.push(
              {
                name: 'Last Visit',
                selector: (row) => row.lastvisitdate,
                cell: (row) =>
                  row.lastvisitdate
                    ? <span style={{ fontSize: 12, color: '#475569', fontWeight: 500 }}>{new Date(row.lastvisitdate).toLocaleDateString('en-GB')}</span>
                    : <span style={{ color: '#cbd5e1' }}>—</span>,
                sortable: true,
              },
              {
                name: 'Actions',
                filterable: false,
                actions: (row) => [
                  { icon: "⏱️", label: "Schedule", desc: "Schedule for tomorrow / future", onClick: () => this.openScheduleModal(row) },
                  { icon: "🧘", label: "Move to Session", desc: "Move patient to a session", onClick: () => this.moveToSession(row) },
                  ...(canDo(this.state.auth, 'billing.view')
                    ? [{ icon: <FaRupeeSign size={20} color="blue" />, label: "View Bills", desc: "Fetch billing records", onClick: () => this.fetchBillsByCard(row) }]
                    : []),
                  { icon: <FaEdit size={20} color="green" />, label: "Edit", desc: "Edit patient details", onClick: () => this.handleEditPatient(row._id) },
                  ...(isOwner
                    ? [{ icon: <FaTrash size={20} color="red" />, label: "Delete", desc: "Permanently delete patient", onClick: () => this.handleDeletePatient(row._id) }]
                    : []),
                ],
              },

  )
  // Define FormInput as a class property arrow function
  this.FormInput = ({ label, value, field, type = 'text', maxLength }) => {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input
          type={type}
          value={value || ''}
          maxLength={maxLength}
          onChange={(e) => this.handleFieldChange(field, e.target.value)}
          style={inputStyle}
          onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
          onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
        />
      </div>
    );
  };

  const globalSearch = (this.state.globalSearch || '').trim().toLowerCase();

  const filteredPatients = patients.filter((patient) => {
    // Global search — match ALL words against card, name, or number
    if (globalSearch) {
      var words = globalSearch.split(/\s+/);
      var pName = (patient.name || '').toLowerCase();
      var pCard = ((patient.patientCard || '') + '').toLowerCase();
      var pNum = ((patient.number ?? '') + '').toLowerCase();
      var allMatch = words.every(function(w) {
        return pName.indexOf(w) !== -1 || pCard.indexOf(w) !== -1 || pNum.indexOf(w) !== -1;
      });
      if (!allMatch) return false;
    }

    // Per-column filters (split name filter by words for multi-word search)
    var nameFilter = (filters.name || '').trim().toLowerCase();
    var nameMatch = true;
    if (nameFilter) {
      var nameWords = nameFilter.split(/\s+/);
      var patName = (patient.name || '').toLowerCase();
      nameMatch = nameWords.every(function(w) { return patName.indexOf(w) !== -1; });
    }

    const lastVisit = patient.lastvisitdate
      ? new Date(patient.lastvisitdate).toLocaleDateString('en-GB').toLowerCase()
      : '';
    return (
      nameMatch &&
      ((patient.patientCard || '') + '').toLowerCase().includes(filters.card.toLowerCase()) &&
      ((patient.number ?? '') + '').toLowerCase().includes(filters.contact.toLowerCase()) &&
      String(patient.pendingvisits || '').toLowerCase().includes(filters.pending.toLowerCase()) &&
      lastVisit.includes(filters.lastVisit.toLowerCase()) &&
      ((patient.therapist || '') + '').toLowerCase().includes(filters.therapist.toLowerCase())
    );
  });

  const { appDialog } = this.state;
  const TOAST_C = { success:{bg:'#e8f5e9',border:'#4caf50',color:'#1b5e20',icon:'✅'}, error:{bg:'#fdecea',border:'#e53935',color:'#b71c1c',icon:'❌'}, info:{bg:'#e3f2fd',border:'#1e88e5',color:'#0d47a1',icon:'ℹ️'}, warning:{bg:'#fff8e1',border:'#fb8c00',color:'#e65100',icon:'⚠️'} };

  return (
    <div>
      <style>{`
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 4px 20px rgba(37,99,235,0.35); }
          50% { box-shadow: 0 4px 30px rgba(37,99,235,0.55), 0 0 20px rgba(59,130,246,0.2); }
        }
        @keyframes pulse-dot {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.5); opacity: 0.7; }
        }
      `}</style>
      {appDialog && appDialog.type === 'alert' && (() => {
        const c = TOAST_C[appDialog.alertType] || TOAST_C.info;
        return (
          <div style={{position:'fixed',top:24,left:'50%',transform:'translateX(-50%)',zIndex:9999,minWidth:280,maxWidth:'90vw',background:c.bg,border:`1.5px solid ${c.border}`,color:c.color,borderRadius:14,padding:'14px 20px',boxShadow:'0 8px 32px rgba(0,0,0,0.15), 0 2px 8px rgba(0,0,0,0.1)',display:'flex',alignItems:'flex-start',gap:12,fontSize:14,fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif",backdropFilter:'blur(8px)',WebkitBackdropFilter:'blur(8px)'}}>
            <span style={{fontSize:18}}>{c.icon}</span>
            <span style={{flex:1,whiteSpace:'pre-wrap'}}>{appDialog.msg}</span>
            <button onClick={this.dismissAppDialog} style={{background:'none',border:'none',cursor:'pointer',color:c.color,fontSize:16,padding:0,marginLeft:6}}>×</button>
          </div>
        );
      })()}
      {appDialog && appDialog.type === 'confirm' && (
        <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.55)',backdropFilter:'blur(8px)',WebkitBackdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:20,maxWidth:420,width:'90vw',boxShadow:'0 25px 80px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.1)',overflow:'hidden',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>
            <div style={{background:'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',padding:'16px 24px',display:'flex',alignItems:'center',gap:10}}>
              <span style={{fontSize:20}}>⚠️</span>
              <span style={{color:'#fff',fontWeight:700,fontSize:15}}>Confirm Action</span>
            </div>
            <div style={{padding:'20px 24px'}}>
              <p style={{fontSize:14,color:'#334155',lineHeight:1.6,marginBottom:24,whiteSpace:'pre-wrap'}}>{appDialog.msg}</p>
              <div style={{display:'flex',gap:12,justifyContent:'flex-end'}}>
                <button style={{padding:'10px 22px',borderRadius:10,border:'1.5px solid #e2e8f0',background:'#fff',color:'#64748b',fontSize:13,fontWeight:600,cursor:'pointer'}} onClick={this.dismissAppDialog}>Cancel</button>
                <button style={{padding:'10px 22px',borderRadius:10,border:'none',background:'#dc2626',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 14px rgba(220,38,38,0.3)'}} onClick={() => { this.dismissAppDialog(); appDialog.onConfirm?.(); }}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isModalOpen && (
        <div style={{ maxWidth: 1400, margin: '0 auto', padding: '0 16px' }}>
          {/* ── Top Header Bar ── */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            flexWrap: 'wrap', gap: 12, marginBottom: 20, marginTop: 8,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 42, height: 42, borderRadius: 12,
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: 20, fontWeight: 800, flexShrink: 0,
              }}>S</div>
              <div>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#1e293b', letterSpacing: -0.5 }}>Saadhaks</div>
                {this.state.totalPatients > 0 && (
                  <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 500 }}>
                    {this.state.totalPatients} total
                  </div>
                )}
              </div>
            </div>

            <button
              onClick={this.handleAddNewPatient}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '10px 22px', borderRadius: 10,
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                border: 'none', color: '#fff', fontSize: 14, fontWeight: 700,
                cursor: 'pointer', boxShadow: '0 4px 14px rgba(37,99,235,0.3)',
                marginTop: 0,
              }}
            >
              <span style={{ fontSize: 18, lineHeight: 1 }}>+</span>
              Add New Patient
            </button>
          </div>

          {/* ── Stats Cards — owner/solution always; others need patients.view_stats ── */}
          {canDo(this.state.auth, 'patients.view_stats') && (() => {
            const st = this.state;
            const activeCount = st.serverActiveNow;
            const pendingBal = st.serverOutstanding;
            const canSeeBills = canDo(st.auth, 'billing.view');
            const sf = st.statsFilter;
            const self = this;
            function handleCardClick(filterKey) {
              const newFilter = sf === filterKey ? null : filterKey;
              self.setState({ statsFilter: newFilter }, function() {
                self.fetchData(0, undefined, newFilter);
              });
            }
            // Sub-count chip renderer
            function subChip(label, count, color, filterKey) {
              if (count === 0 && filterKey !== sf) return null;
              var isActive = sf === filterKey;
              return (
                <span key={filterKey}
                  onClick={function(e) { e.stopPropagation(); handleCardClick(filterKey); }}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 3,
                    padding: '2px 7px', borderRadius: 8, cursor: 'pointer',
                    fontSize: 11, fontWeight: 700, lineHeight: '16px',
                    background: isActive ? color : color + '18',
                    color: isActive ? '#fff' : color,
                    border: isActive ? '1.5px solid ' + color : '1px solid ' + color + '30',
                  }}>
                  {count} {label}
                </span>
              );
            }
            // Helper: format date string "2026-10-03" → "3 Oct"
            var dr = st.dateRanges || {};
            function fmtDate(s) {
              if (!s) return '';
              var parts = s.split('-');
              var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
              return parseInt(parts[2],10) + ' ' + months[parseInt(parts[1],10)-1];
            }
            // Cards: Total, Active Now, Today (with sub-counts), Week, Month, Outstanding
            var cards = [
              { label: 'Total', value: st.totalPatients || patients.length, color: '#2563eb', bg: '#eff6ff', icon: '\uD83D\uDC65' },
            ];
            if (activeCount > 0) {
              cards.push({ label: 'Active Now', value: activeCount, color: '#059669', bg: '#ecfdf5', icon: '\uD83D\uDFE2', filterKey: 'active' });
            }
            // Today card with sub-counts
            var todayTotal = st.todayScheduled + st.todayInProgress + st.todayCompleted + st.todayMissed;
            cards.push({
              label: 'Today', value: todayTotal, color: '#0d9488', bg: '#f0fdfa', icon: '\uD83D\uDCC5',
              dateHint: dr.todayDate ? fmtDate(dr.todayDate) : '',
              subs: [
                { label: 'Scheduled', count: st.todayScheduled, color: '#2563eb', filterKey: 'today_scheduled' },
                { label: 'In Progress', count: st.todayInProgress, color: '#059669', filterKey: 'today_inprogress' },
                { label: 'Completed', count: st.todayCompleted, color: '#0d9488', filterKey: 'today_completed' },
                { label: 'Missed', count: st.todayMissed, color: '#dc2626', filterKey: 'today_missed' },
              ],
            });
            // Week card
            var weekTotal = st.weekScheduled + st.weekCompleted + st.weekMissed;
            cards.push({
              label: 'This Week', value: weekTotal, color: '#7c3aed', bg: '#f5f3ff', icon: '\uD83D\uDCC6',
              dateHint: (dr.weekFrom && dr.weekTo) ? fmtDate(dr.weekFrom) + ' \u2013 ' + fmtDate(dr.weekTo) : '',
              subs: [
                { label: 'Scheduled', count: st.weekScheduled, color: '#2563eb', filterKey: 'week_scheduled' },
                { label: 'Completed', count: st.weekCompleted, color: '#0d9488', filterKey: 'week_completed' },
                { label: 'Missed', count: st.weekMissed, color: '#dc2626', filterKey: 'week_missed' },
              ],
            });
            // Month card
            var monthTotal = st.monthScheduled + st.monthCompleted + st.monthMissed;
            cards.push({
              label: 'This Month', value: monthTotal, color: '#6366f1', bg: '#eef2ff', icon: '\uD83D\uDCCA',
              dateHint: (dr.monthFrom && dr.monthTo) ? fmtDate(dr.monthFrom) + ' \u2013 ' + fmtDate(dr.monthTo) : '',
              subs: [
                { label: 'Scheduled', count: st.monthScheduled, color: '#2563eb', filterKey: 'month_scheduled' },
                { label: 'Completed', count: st.monthCompleted, color: '#0d9488', filterKey: 'month_completed' },
                { label: 'Missed', count: st.monthMissed, color: '#dc2626', filterKey: 'month_missed' },
              ],
            });
            if ((canSeeOutstanding || canSeeBills) && pendingBal !== 0) {
              cards.push({ label: 'Outstanding', value: '\u20B9' + Math.round(pendingBal).toLocaleString('en-IN'), color: pendingBal > 0 ? '#dc2626' : '#059669', bg: pendingBal > 0 ? '#fef2f2' : '#ecfdf5', icon: '\uD83D\uDCB0' });
            }
            return (
              <div style={{ display: '-webkit-flex', display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                {cards.map(function(s, i) {
                  var cardActive = sf && sf === s.filterKey;
                  var clickable = !!s.filterKey;
                  return (
                    <div key={i}
                      onClick={clickable ? function() { handleCardClick(s.filterKey); } : undefined}
                      style={{
                        background: cardActive ? s.color : s.bg,
                        borderRadius: 10, padding: '8px 14px',
                        border: cardActive ? '2px solid ' + s.color : '1px solid ' + s.color + '22',
                        boxShadow: cardActive ? '0 2px 8px ' + s.color + '40' : '0 1px 3px rgba(0,0,0,0.04)',
                        cursor: clickable ? 'pointer' : 'default',
                        transition: 'all 0.15s ease',
                        minWidth: 0, flex: '0 1 auto',
                      }}>
                      <div style={{ display: '-webkit-flex', display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontSize: 15, lineHeight: 1 }}>{s.icon}</span>
                        <span style={{ fontSize: 18, fontWeight: 800, color: cardActive ? '#fff' : s.color, lineHeight: 1 }}>{s.value}</span>
                      </div>
                      <div style={{ fontSize: 10, fontWeight: 600, color: cardActive ? 'rgba(255,255,255,0.85)' : '#64748b', marginTop: 2, whiteSpace: 'nowrap' }}>{s.label}</div>
                      {s.dateHint && <div style={{ fontSize: 9, color: cardActive ? 'rgba(255,255,255,0.65)' : '#94a3b8', marginTop: 1, whiteSpace: 'nowrap' }}>{s.dateHint}</div>}
                      {s.subs && (
                        <div style={{ display: '-webkit-flex', display: 'flex', flexWrap: 'wrap', gap: 3, marginTop: 5 }}>
                          {s.subs.map(function(sub) { return subChip(sub.label, sub.count, sub.color, sub.filterKey); })}
                        </div>
                      )}
                    </div>
                  );
                })}
                {sf && (
                  <div
                    onClick={function() { handleCardClick(sf); }}
                    style={{
                      display: '-webkit-flex', display: 'flex', alignItems: 'center', gap: 4,
                      background: '#fef2f2', borderRadius: 10, padding: '8px 12px',
                      border: '1px solid #fecaca', cursor: 'pointer', alignSelf: 'center',
                    }}>
                    <span style={{ fontSize: 12, color: '#dc2626', fontWeight: 600 }}>Clear filter</span>
                    <span style={{ fontSize: 14, color: '#dc2626', fontWeight: 700 }}>×</span>
                  </div>
                )}
              </div>
            );
          })()}

          {/* ── Content ── */}
          {this.state.loading && patients.length === 0 ? (
            <div style={{
              textAlign: 'center', padding: '80px 20px',
              background: '#f8fafc', borderRadius: 16,
            }}>
              <div style={{
                width: 48, height: 48, borderRadius: '50%',
                border: '4px solid #e2e8f0', borderTopColor: '#2563eb',
                animation: 'spin 0.8s linear infinite',
                margin: '0 auto 16px',
              }} />
              <div style={{ fontSize: 15, fontWeight: 600, color: '#64748b' }}>Loading patients...</div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>Fetching records from server</div>
            </div>
          ) : (
            <>
            {/* Refresh banner — shown when new data is available */}
            {this.state.pendingSummary && (
              <div
                onClick={this.applyPendingSummary}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                  padding: '12px 20px', marginBottom: 12,
                  background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%)',
                  borderRadius: 12, cursor: 'pointer',
                  boxShadow: '0 4px 20px rgba(37,99,235,0.35)',
                  animation: 'pulse-glow 2s ease-in-out infinite',
                  transition: 'transform 0.15s, box-shadow 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.01)'; e.currentTarget.style.boxShadow = '0 6px 28px rgba(37,99,235,0.5)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(37,99,235,0.35)'; }}
              >
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#34d399', boxShadow: '0 0 8px #34d399', flexShrink: 0 }} />
                <span style={{ color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: '0.01em' }}>
                  New data available — Click to refresh
                </span>
                <span style={{ color: '#bfdbfe', fontSize: 20, fontWeight: 700 }}>↻</span>
              </div>
            )}
            {/* Unified search bar — searches card, name, number together */}
            <div style={{
              display: '-webkit-flex', display: 'flex', alignItems: 'center',
              background: '#fff', borderRadius: 12, padding: '6px 12px', marginBottom: 10,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 2px 8px rgba(0,0,0,0.04)',
              border: '1.5px solid #e2e8f0',
            }}>
              <span style={{ color: '#94a3b8', fontSize: 18, marginRight: 8, flexShrink: 0 }}>{'\uD83D\uDD0D'}</span>
              <input
                type="text"
                placeholder="Search by name, card or number\u2026"
                value={this.state.globalSearch || ''}
                onChange={e => {
                  var val = e.target.value;
                  this.setState({ globalSearch: val });
                  // Debounced server-side search for queries >= 2 chars
                  clearTimeout(this._searchTimer);
                  if (val.trim().length >= 2) {
                    this._searchTimer = setTimeout(() => {
                      this.setState({ loading: true });
                      api.get(process.env.REACT_APP_URL + '/patients/profiles/page?search=' + encodeURIComponent(val.trim()) + '&t=' + Date.now())
                        .then(res => {
                          var d = res.data;
                          this.setState({ patients: d.patients || d, loading: false });
                        })
                        .catch(() => this.setState({ loading: false }));
                    }, 400);
                  } else if (val.trim().length === 0) {
                    // Cleared — reload default list
                    this.fetchData();
                  }
                }}
                style={{
                  border: 'none', outline: 'none', flex: 1, fontSize: 15, fontWeight: 500,
                  padding: '8px 0', background: 'transparent', color: '#1e293b',
                  minWidth: 0, WebkitAppearance: 'none',
                }}
              />
              {this.state.globalSearch && (
                <span onClick={() => { this.setState({ globalSearch: '' }); this.fetchData(); }}
                  style={{ color: '#94a3b8', fontSize: 20, fontWeight: 700, cursor: 'pointer', padding: '0 4px', flexShrink: 0 }}>
                  ×
                </span>
              )}
            </div>
            <div style={{
              background: '#fff', borderRadius: 16,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)',
              overflow: 'hidden',
            }}>
              <CustomDataTable
                columns={tableCols}
                data={filteredPatients}
                paginationPerPage={200}
                serverTotal={this.state.totalPatients}
                onPageChange={this.handleCdtPageChange}
                onRowsPerPageChange={this.handleCdtRowsPerPageChange}
                selectableRows={false}
                expandableRowsComponent={SaadhakExpandedRow}
              />
            </div>
            </>
          )}
        </div>
      )}

      {/* PatientDetails Modal or Inline View */}
      {isModalOpen && (
        <>
          {hasModalChanged && modalData && !therapistView && (
            <div className="patient-details-wrapper">
              {console.log('modalData being passed to PatientDetails:', modalData)}
              <PatientDetails patientData={modalData} tabToSelect={tabToSelect} isTherapistView={false} isOwner={isOwner} onClose={this.handleClose} />
            </div>
          )}
          {hasModalChanged && modalData && therapistView && (
            <div className="patient-details-wrapper">
              {console.log('selectedPatient being passed to PatientDailyActivity:', selectedPatient)}
              <PatientDetails patientData={modalData} tabToSelect={"PatientSequences"} isTherapistView={true} isOwner={isOwner} onClose={this.handleClose} />
            </div>
          )}
          {!hasModalChanged && (
            <div style={{
              position: 'fixed', inset: 0, zIndex: 9000,
              background: 'rgba(15,23,42,0.6)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: 16,
            }} onClick={this.handleClose}>
              <div style={{
                background: '#fff',
                borderRadius: 20,
                boxShadow: '0 25px 80px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.1)',
                width: '100%',
                maxWidth: 680,
                maxHeight: '92vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }} onClick={e => e.stopPropagation()}>

                {/* Modal header */}
                <div style={{
                  background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',
                  padding: '0 24px',
                  height: 56,
                  display: 'flex', alignItems: 'center', gap: 12,
                  flexShrink: 0,
                }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: 10,
                    background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(4px)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 16,
                  }}>{isEditMode ? '✏️' : '➕'}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', letterSpacing: -0.3 }}>
                      {isEditMode ? 'Edit Patient' : 'New Patient Registration'}
                    </div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', fontWeight: 500 }}>
                      {isEditMode ? sp?.patientCard || '' : 'Fill in patient details below'}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={this.handleClose}
                    style={{
                      width: 30, height: 30, borderRadius: 8,
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      color: '#fff', fontSize: 16, fontWeight: 700,
                      cursor: 'pointer',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                  >×</button>
                </div>

                {/* Scrollable body */}
                <div style={{ overflowY: 'auto', flex: 1, padding: '24px 28px', background: '#fafbfc' }}>
                  <form onSubmit={this.handleSubmit}>

                    {/* ── Photo section ── */}
                    {this.state.showCamera ? (
                      <div style={{ marginBottom: 20, position: 'relative' }}>
                        <ClickPicture
                          onCapture={this.handleImageCaptured}
                          onClose={() => this.setShowCamera(false)}
                        />
                        <button
                          type="button"
                          onClick={() => this.setShowCamera(false)}
                          style={{
                            marginTop: 10, padding: '8px 20px', borderRadius: 8,
                            border: '1px solid #e5e7eb', background: '#f9fafb',
                            color: '#374151', fontSize: 13, cursor: 'pointer',
                          }}
                        >
                          Cancel Camera
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 22 }}>
                        {(isEditMode ? sp.pic : np.pic) ? (
                          <SafeImage
                            src={isEditMode ? sp.pic : np.pic}
                            alt="Patient"
                            style={{
                              width: 72, height: 72, borderRadius: '50%',
                              objectFit: 'cover', border: '3px solid #e5e7eb', flexShrink: 0,
                            }}
                          />
                        ) : (
                          <div style={{
                            width: 72, height: 72, borderRadius: '50%',
                            background: '#f3f4f6', border: '2px dashed #d1d5db',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 26, color: '#9ca3af', flexShrink: 0,
                          }}>👤</div>
                        )}
                        <div>
                          <button
                            type="button"
                            onClick={() => this.setShowCamera(true)}
                            style={{
                              padding: '8px 16px', borderRadius: 8,
                              border: '1.5px dashed #2563eb', background: '#eff6ff',
                              color: '#1d4ed8', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                            }}
                          >
                            📷 {(isEditMode ? sp.pic : np.pic) ? 'Change Photo' : 'Camera'}
                          </button>
                          <label style={{
                            display: 'inline-block', marginLeft: 8,
                            padding: '8px 16px', borderRadius: 8,
                            border: '1.5px dashed #059669', background: '#ecfdf5',
                            color: '#047857', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                          }}>
                            📁 Upload
                            <input type="file" accept="image/*" style={{ display: 'none' }}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (!file) return;
                                this.setState({ photoFile: file });
                                const reader = new FileReader();
                                reader.onload = () => this.handleImageCaptured(reader.result);
                                reader.readAsDataURL(file);
                              }}
                            />
                          </label>
                          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 5 }}>
                            Photo uploaded to Drive · encrypted &amp; compressed
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ── Field grid ── */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px 24px' }}>

                      {/* Branch */}
                      <div>
                        <label style={labelStyle}>Branch</label>
                        <select
                          value={patient.branch || ''}
                          onChange={(e) => this.handleFieldChange('branch', e.target.value)}
                          style={inputStyle}
                        >
                          <option value="">Select Branch</option>
                          {(branches || []).filter(b => b.isActive !== false && b.status !== 'inactive').map((branch) => (
                            <option key={branch.name} value={branch.name}>{branch.name}</option>
                          ))}
                        </select>
                      </div>

                      {/* Health Card ID — auto-generated, read-only */}
                      <div>
                        <label style={labelStyle}>Health Card ID</label>
                        <input
                          type="text"
                          value={isEditMode ? sp.patientCard : (np.patientCard || 'Generating...')}
                          readOnly
                          style={{ ...inputStyle, background: '#f3f4f6', color: '#374151', fontWeight: 600 }}
                        />
                      </div>

                      {/* Name */}
                      {this.FormInput({ label: 'Full Name', value: isEditMode ? sp.name : np.name, field: 'name' })}

                      {/* Contact */}
                      {this.FormInput({ label: 'Contact Number', value: isEditMode ? sp.number : np.number, field: 'number', type: 'text', maxLength: 10, inputMode: 'numeric' })}

                      {/* Age */}
                      {this.FormInput({ label: 'Age', value: isEditMode ? sp.age : np.age, field: 'age', type: 'text', maxLength: 3, inputMode: 'numeric' })}

                      {/* Occupation */}
                      {this.FormInput({ label: 'Occupation', value: isEditMode ? sp.occu : np.occu, field: 'occu' })}

                      {/* Blood Group */}
                      <div>
                        <label style={labelStyle}>Blood Group</label>
                        <select value={isEditMode ? sp.bg || '' : np.bg || ''} onChange={(e) => this.handleFieldChange('bg', e.target.value)} style={inputStyle}>
                          <option value="">Select</option>
                          {['O-','O+','A-','A+','B-','B+','AB-','AB+'].map(bg => <option key={bg} value={bg}>{bg}</option>)}
                        </select>
                      </div>

                      {/* Gender */}
                      <div>
                        <label style={labelStyle}>Gender</label>
                        <select value={isEditMode ? sp.gender || '' : np.gender || ''} onChange={(e) => this.handleFieldChange('gender', e.target.value)} style={inputStyle}>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="noanswer">Prefer Not to Answer</option>
                        </select>
                      </div>

                      {/* Address — full width */}
                      <div style={{ gridColumn: '1 / -1' }}>
                        {this.FormInput({ label: 'Address', value: isEditMode ? sp.address : np.address, field: 'address' })}
                      </div>

                      {/* Nature of Work — full width */}
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={{ display: 'block', marginBottom: 8, fontSize: 12, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Nature of Work</label>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                          {['sit','stand','travel','mix','other'].map(k => {
                            const now = isEditMode ? (this.state.selectedPatient?.now || {}) : (this.state.newPatient?.now || {});
                            const checked = !!now[k];
                            return (
                              <label key={k} style={{
                                display: 'flex', alignItems: 'center', gap: 7,
                                padding: '7px 14px', borderRadius: 8,
                                border: `1.5px solid ${checked ? '#2563eb' : '#e5e7eb'}`,
                                background: checked ? '#eff6ff' : '#fafafa',
                                color: checked ? '#1d4ed8' : '#374151',
                                fontSize: 13, fontWeight: 500, cursor: 'pointer',
                                transition: 'all 0.12s',
                              }}>
                                <input
                                  type="checkbox"
                                  checked={checked}
                                  onChange={e => this.handleCheckboxChange('now', k, e.target.checked)}
                                  style={{ accentColor: '#2563eb', width: 15, height: 15 }}
                                />
                                {k.charAt(0).toUpperCase() + k.slice(1)}
                              </label>
                            );
                          })}
                        </div>
                      </div>

                      {/* Registration Date */}
                      <div>
                        <label style={labelStyle}>Registration Date (if old)</label>
                        <DatePicker
                          selected={isEditMode ? sp.registrationDate : this.state.registrationDate}
                          onChange={date => {
                            if (isEditMode) this.handleFieldChange('registrationDate', date);
                            else this.setState({ registrationDate: date });
                          }}
                          dateFormat="dd/MM/yyyy"
                          wrapperClassName="datepicker-full"
                          customInput={<input style={inputStyle} />}
                        />
                      </div>

                    </div>

                    {/* Submit */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 28, paddingTop: 20, borderTop: '1px solid #e2e8f0', gap: 12, flexWrap: 'wrap' }}>
                      <button
                        type="button"
                        onClick={this.handleClose}
                        style={{
                          padding: '11px 22px', borderRadius: 10,
                          border: '1.5px solid #e2e8f0', background: '#fff',
                          color: '#64748b', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                          transition: 'all 0.15s',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                      >
                        Cancel
                      </button>
                      {!isEditMode && (
                        <button
                          type="button"
                          onClick={this.handleAddWithConsultationBill}
                          style={{
                            padding: '11px 24px', borderRadius: 10,
                            background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                            border: 'none', color: '#fff',
                            fontSize: 13, fontWeight: 700, cursor: 'pointer',
                            boxShadow: '0 4px 14px rgba(16,185,129,0.25)',
                            transition: 'all 0.15s',
                          }}
                          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(16,185,129,0.35)'; }}
                          onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(16,185,129,0.25)'; }}
                        >
                          Add & Bill Consultation
                        </button>
                      )}
                      <button
                        type="submit"
                        style={{
                          padding: '11px 30px', borderRadius: 10,
                          background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',
                          border: 'none', color: '#fff',
                          fontSize: 13, fontWeight: 700, cursor: 'pointer',
                          boxShadow: '0 4px 14px rgba(37,99,235,0.3)',
                          transition: 'all 0.15s',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(37,99,235,0.4)'; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(37,99,235,0.3)'; }}
                      >
                        {isEditMode ? 'Update Patient' : 'Add Patient'}
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {this.state.showBillsModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.6)',
          backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, padding: 16,
        }} onClick={() => this.setState({ showBillsModal: false, selectedPatient: null })}>
          <div style={{
            background: '#fff', borderRadius: 20, width: '92%', maxWidth: 920,
            maxHeight: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden',
            boxShadow: '0 25px 80px rgba(0,0,0,0.2), 0 0 0 1px rgba(255,255,255,0.1)',
          }} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',
              padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              flexShrink: 0,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 10,
                  background: 'rgba(255,255,255,0.12)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18,
                }}>₹</div>
                <div>
                  <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, letterSpacing: -0.3 }}>Billing History</div>
                  <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginTop: 1, fontWeight: 500 }}>
                    {this.state.selectedPatient?.name} · {this.state.selectedPatient?.patientCard}
                  </div>
                </div>
              </div>
              <button onClick={() => this.setState({ showBillsModal: false, selectedPatient: null })} style={{
                width: 30, height: 30, borderRadius: 8, background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)', color: '#fff', fontSize: 16,
                fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center',
                justifyContent: 'center', marginTop: 0, transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
              >×</button>
            </div>

            {/* Summary Cards */}
            {(() => {
              const totalSum = this.state.bills.reduce((acc, b) => acc + b.total, 0);
              const discountSum = this.state.bills.reduce((acc, b) => acc + b.discount, 0);
              const paidSum = this.state.bills.reduce((acc, b) => acc + b.paid, 0);
              const givenBackSum = this.state.bills.reduce((acc, b) => acc + b.givenback, 0);
              const { bal } = this.getpreviousOutstandingWithOrgs(this.state.selectedPatient);
              return (
                <div style={{
                  display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
                  gap: 10, padding: '16px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
                }}>
                  {[
                    { label: 'Total', value: `₹${totalSum.toLocaleString('en-IN')}`, color: '#0f172a', bg: '#fff', border: '#e2e8f0' },
                    { label: 'Discount', value: `₹${discountSum.toLocaleString('en-IN')}`, color: '#1d4ed8', bg: '#eff6ff', border: '#bfdbfe' },
                    { label: 'Received', value: `₹${paidSum.toLocaleString('en-IN')}`, color: '#15803d', bg: '#f0fdf4', border: '#bbf7d0' },
                    { label: 'Change', value: `₹${givenBackSum.toLocaleString('en-IN')}`, color: '#b45309', bg: '#fffbeb', border: '#fde68a' },
                    { label: 'Balance', value: `₹${Math.round(bal).toLocaleString('en-IN')}`, color: bal > 0 ? '#dc2626' : '#15803d', bg: bal > 0 ? '#fef2f2' : '#f0fdf4', border: bal > 0 ? '#fecaca' : '#bbf7d0' },
                  ].map((s, i) => (
                    <div key={i} style={{
                      textAlign: 'center', padding: '10px 8px',
                      borderRadius: 10, background: s.bg, border: `1px solid ${s.border}`,
                    }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{s.label}</div>
                      <div style={{ fontSize: 17, fontWeight: 800, color: s.color, marginTop: 3, fontFamily: "'Inter','SF Pro Display',system-ui,sans-serif" }}>{s.value}</div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Tab Bar */}
            <div style={{ display: 'flex', gap: 0, padding: '0 24px', borderBottom: '1px solid #e2e8f0', background: '#fff' }}>
              {[
                { key: 'MYCTherapy', label: 'MedicalYoga' },
                { key: 'ReRoot', label: 'ReRoot' },
              ].map(t => (
                <button key={t.key} onClick={() => this.setState({ activeTab: t.key })} style={{
                  padding: '12px 22px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
                  border: 'none', borderBottom: this.state.activeTab === t.key ? '2.5px solid #1d4ed8' : '2.5px solid transparent',
                  background: 'none', color: this.state.activeTab === t.key ? '#1d4ed8' : '#94a3b8',
                  marginTop: 0, marginBottom: -1, transition: 'all 0.15s',
                  fontFamily: "'Inter','SF Pro Display',system-ui,sans-serif",
                }}>{t.label}</button>
              ))}
            </div>

            {/* Table */}
            <div style={{ overflowY: 'auto', flex: 1, padding: '8px 16px 16px' }}>
              {this.state.activeTab === "MYCTherapy" && (
                <DataTable
                  columns={this.billColumns}
                  data={this.state.bills.filter(s => s.billorg === "MedicalyogaTherapyCentre")}
                  expandableRows expandableRowsComponent={this.BillDetails}
                  dense highlightOnHover
                />
              )}
              {this.state.activeTab === "ReRoot" && (
                <DataTable
                  columns={this.billColumns}
                  data={this.state.bills.filter(s => s.billorg === "ReRoot")}
                  expandableRows expandableRowsComponent={this.BillDetails}
                  dense highlightOnHover
                />
              )}
            </div>
          </div>
        </div>
      )}
           
      
      {this.state.showScheduleModal && this.state.selectedAppt && ReactDOM.createPortal(
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.6)',
          backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, padding: 16,
        }} onClick={this.closeModal}>
          <div style={{
            background: '#fff', borderRadius: 20, width: '100%', maxWidth: 560,
            maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
            boxShadow: '0 25px 80px rgba(0,0,0,0.2), 0 0 0 1px rgba(255,255,255,0.1)',
          }} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',
              padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 10,
                  background: 'rgba(255,255,255,0.12)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18,
                }}>📅</div>
                <div>
                  <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, letterSpacing: -0.3 }}>Schedule Appointment</div>
                  <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginTop: 1, fontWeight: 500 }}>{this.state.selectedAppt.name}</div>
                </div>
              </div>
              <button onClick={this.closeModal} style={{
                width: 30, height: 30, borderRadius: 8, background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)', color: '#fff', fontSize: 16,
                fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center',
                justifyContent: 'center', marginTop: 0, transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
              >×</button>
            </div>

            {/* Body */}
            <div style={{ padding: '22px 24px', overflowY: 'auto', flex: 1, background: '#fafbfc' }}>

              {/* Online / Offline toggle */}
              <div style={{ marginBottom: 22 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#475569', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Session Mode</div>
                <div style={{ display: 'flex', gap: 0, borderRadius: 10, overflow: 'hidden', border: '1.5px solid #e2e8f0', width: 'fit-content' }}>
                  <button onClick={() => this.setState({ isOnlineSchedule: false })} style={{
                    padding: '10px 22px', fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer', marginTop: 0,
                    background: !this.state.isOnlineSchedule ? 'linear-gradient(135deg, #1d4ed8, #3b82f6)' : '#fff',
                    color: !this.state.isOnlineSchedule ? '#fff' : '#64748b',
                    transition: 'all 0.15s',
                  }}>At Centre</button>
                  <button onClick={() => this.setState({ isOnlineSchedule: true })} style={{
                    padding: '10px 22px', fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer', marginTop: 0,
                    background: this.state.isOnlineSchedule ? 'linear-gradient(135deg, #059669, #10b981)' : '#fff',
                    color: this.state.isOnlineSchedule ? '#fff' : '#64748b',
                    transition: 'all 0.15s',
                  }}>Online</button>
                </div>
              </div>

              {!this.state.showDatePicker && (
                <>
                  <div style={{ display: 'flex', gap: 12, marginBottom: 22 }}>
                    <button onClick={() => {
                      const now = new Date();
                      const tomorrow = new Date(now);
                      tomorrow.setDate(now.getDate() + 1);
                      this.setState({ showDatePicker: false });
                      this.scheduleAppointment(this.state.selectedAppt, tomorrow);
                    }} style={{
                      flex: 1, padding: '13px 16px', borderRadius: 12,
                      background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                      border: 'none', color: '#fff', fontSize: 13, fontWeight: 700,
                      cursor: 'pointer', boxShadow: '0 4px 14px rgba(16,185,129,0.25)', marginTop: 0,
                      transition: 'all 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(16,185,129,0.35)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(16,185,129,0.25)'; }}
                    >Tomorrow</button>
                    <button onClick={() => this.setState({ showDatePicker: true })} style={{
                      flex: 1, padding: '13px 16px', borderRadius: 12,
                      background: '#fff', border: '1.5px solid #bfdbfe',
                      color: '#1d4ed8', fontSize: 13, fontWeight: 700, cursor: 'pointer', marginTop: 0,
                      transition: 'all 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#eff6ff'; e.currentTarget.style.borderColor = '#93c5fd'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#bfdbfe'; }}
                    >Pick Date & Time</button>
                  </div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#475569', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    Existing Appointments
                  </div>
                  <MiniCalendarWithBlocks appointments={this.state.allappointments} />
                </>
              )}

              {this.state.showDatePicker && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center' }}>
                  <DatePicker
                    selected={this.state.futureDate}
                    onChange={(date) => this.setState({ futureDate: date })}
                    showTimeSelect timeIntervals={30} timeCaption="Time"
                    dateFormat="Pp" minDate={new Date()} inline
                  />
                  <div style={{ display: 'flex', gap: 12, width: '100%' }}>
                    <button onClick={this.closeModal} style={{
                      flex: 1, padding: '12px 16px', borderRadius: 10,
                      background: '#fff', border: '1.5px solid #e2e8f0',
                      color: '#64748b', fontSize: 13, fontWeight: 600, cursor: 'pointer', marginTop: 0,
                      transition: 'all 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f8fafc'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
                    >Cancel</button>
                    <button disabled={!this.state.futureDate} onClick={() => {
                      const selected = this.state.futureDate;
                      if (!selected) return;
                      if (selected < new Date()) { alert("Please select a future time."); return; }
                      this.scheduleAppointment(this.state.selectedAppt, selected);
                    }} style={{
                      flex: 2, padding: '12px 16px', borderRadius: 10,
                      background: this.state.futureDate ? 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)' : '#e2e8f0',
                      border: 'none', color: this.state.futureDate ? '#fff' : '#94a3b8',
                      fontSize: 13, fontWeight: 700, cursor: this.state.futureDate ? 'pointer' : 'not-allowed', marginTop: 0,
                      boxShadow: this.state.futureDate ? '0 4px 14px rgba(37,99,235,0.3)' : 'none',
                      transition: 'all 0.15s',
                    }}>Schedule</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      , document.body)}

    </div>
  );
};

}

export default ListPatients;
